import { AppEnvs } from 'enums';
import {
    NIELSEN_APPID_EPLUS,
    NIELSEN_APPID_TVE
} from 'constants';

export default (nielsenTrackingData, moreCustomMetadata = {}, env = AppEnvs.prod, player) => {
    const { ReportSuite } = nielsenTrackingData;
    delete nielsenTrackingData.ReportSuite;

    let apid = NIELSEN_APPID_TVE;
    if (player === 'bam') {
        apid = NIELSEN_APPID_EPLUS;
    }

    const isSecureProtocol = (
        window &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https') > -1
    );

    const data = {
        APP_MEASUREMENT: {
            RSID: `${ReportSuite}${env === AppEnvs.prod ? ',wdgespge' : ''}`,
            TRACKING_SERVER: isSecureProtocol ? 'sw88.espn.com' : 'w88.espn.com',
            TRACKING_SERVER_SECURE: 'sw88.espn.com'
        },
        ESPN_CUSTOM_METADATA: { ...nielsenTrackingData, ...moreCustomMetadata },
        HEARTBEAT: {
            DEBUG_LOGGING: false
        },
        NIELSEN_DATA: {
            APP_INFO: {
                apid,
                clientId: 'us-600140',
                sfcode: 'dcr',
                DEV: {
                    apid,
                    clientId: 'us-600140',
                    sfcode: 'dcr'
                },
                PROD: {
                    apid,
                    clientId: 'us-600140',
                    sfcode: 'dcr'
                }
            },
            CONTENT_METADATA: {
                segA: nielsenTrackingData.SegA,
                segC: nielsenTrackingData.SegC,
                isfullepisode: nielsenTrackingData.isfullepisode
            }
        }
    };
    return data;
};



// WEBPACK FOOTER //
// ./app/webapp/player/util/getAdobeDCRConfig.js